import { configureStore } from '@reduxjs/toolkit'
import formReducer from './formSlice.js'
const store= configureStore({
  reducer: {
    form:formReducer
  }
})
export default store;